import { AccountingFilterRequest } from "@/models/accounting";
import { EmployeeDocsFilterRequest } from "@/models/apiModels";
import { EmployeeGroupFilterRequest, OrganizationDepartmentFilterRequest } from "@/models/departmentGroup";
import {
    DigitalWalletFilterRequest,
    DigitalWalletManagementFilterRequest,
    EmployeeDigitalWalletFilterRequest,
} from "@/models/digital.wallet";
import { EmployeeFilterResource, EmployeeOrdersFilterRequest } from "@/models/employees";
import { FormsFilterRequest } from "@/models/forms";
import { InterfaceFilterRequest, InterfaceTransactionFilterRequest } from "@/models/interfaces";
import { OrdersFilterRequest } from "@/models/orders";
import { FilterProfilesRequest, FilterUsersRequest } from "@/models/user";
import { makeAutoObservable } from "mobx";

export class FiltersStore {
    employeesFilterData: EmployeeFilterData | null = null;
    employeesWalletFilterData: EmployeeDigitalWalletFilterRequest | null = null;
    employeesOrderFilterData: EmployeeOrdersFilterRequest | null = null;
    employeesDocsFilterData: EmployeeDocsFilterRequest | null = null;
    digitalWalletsFilterData: DigitalWalletsFilterData | null = null;
    digitalWalletsHiddenFilter: boolean | null = null;
    digitalWalletManagmentFilterData: DigitalWalletManagementFilterRequest | null = null;
    digitalWalletManagmentHiddenFilter: boolean | null = null;
    accountingFilterData: AccountingFilterData | null = null;
    accountingHiddenFilter: boolean | null = null;
    ordersFilterData: OrdersFilterData | null = null;
    ordersHiddenFilter: boolean | null = null;
    formsFilterData: FormsFilterRequest | null = null;
    usersFilterData: FilterUsersRequest | null = null;
    profilesFilterData: FilterProfilesRequest | null = null;
    interfacesFilterData: InterfacesFilterData | null = null;
    organizationDepartmentFilterData: OrganizationDepartmentFilterRequest | null = null;
    employeeGroupsFilterData: EmployeeGroupFilterRequest | null = null;

    constructor() {
        makeAutoObservable(this);
    }

    public setEmployeeFilterData(filterData: EmployeeFilterData | null) {
        this.employeesFilterData = filterData;
    }

    public setEmployeeWalletFilterData(filterData: EmployeeDigitalWalletFilterRequest | null) {
        this.employeesWalletFilterData = filterData;
    }

    public setEmployeeOrderFilterData(filterData: EmployeeOrdersFilterRequest | null) {
        this.employeesOrderFilterData = filterData;
    }

    public setEmployeeDocFilterData(filterData: EmployeeDocsFilterRequest | null) {
        this.employeesDocsFilterData = filterData;
    }

    public setDigitalWalletsFilterData(filterData: DigitalWalletsFilterData | null) {
        this.digitalWalletsFilterData = filterData;
    }

    public setDigitalWalletsHiddenFilter(hiddenFilter: boolean | null) {
        this.digitalWalletsHiddenFilter = hiddenFilter;
    }

    public setDigitalWalletManagmentFilterData(filterData: DigitalWalletManagementFilterRequest | null) {
        this.digitalWalletManagmentFilterData = filterData;
    }

    public setDigitalWalletManagmentHiddenFilter(hiddenFilter: boolean | null) {
        this.digitalWalletManagmentHiddenFilter = hiddenFilter;
    }

    public setAccountingFilterData(filterData: AccountingFilterData | null) {
        this.accountingFilterData = filterData;
    }

    public setAccountingHiddenFilter(hiddenFilter: boolean | null) {
        this.accountingHiddenFilter = hiddenFilter;
    }

    public setOrdersFilterData(filterData: OrdersFilterData | null) {
        this.ordersFilterData = filterData;
    }

    public setOrdersHiddenFilter(hiddenFilter: boolean | null) {
        this.ordersHiddenFilter = hiddenFilter;
    }

    public setFormsFilterData(filterData: FormsFilterRequest | null) {
        this.formsFilterData = filterData;
    }

    public setUsersFilterData(filterData: FilterUsersRequest | null) {
        this.usersFilterData = filterData;
    }

    public setProfilesFilterData(filterData: FilterProfilesRequest | null) {
        this.profilesFilterData = filterData;
    }

    public setInterfacesFilterData(filterData: InterfacesFilterData | null) {
        this.interfacesFilterData = filterData;
    }

    public setOrganizationDepartmentFilterData(filterData: OrganizationDepartmentFilterRequest | null) {
        this.organizationDepartmentFilterData = filterData;
    }

    public setEmployeeGroupsFilterData(filterData: EmployeeGroupFilterRequest | null) {
        this.employeeGroupsFilterData = filterData;
    }
}

const filtersStore = new FiltersStore();
export default filtersStore;

export class EmployeeFilterData {
    filter: EmployeeFilterResource | null = null;
    filterTabs: Array<{ id: string; name: string; value: string }> = [];
    hiddenFilter: boolean = false;
}

export class DigitalWalletsFilterData {
    filter: DigitalWalletFilterRequest | null = null;
    filterTabs: Array<{ id: string; name: string; value: string }> = [];
}

export class AccountingFilterData {
    filter: AccountingFilterRequest | null = null;
    filterTabs: Array<{ id: string; name: string; value: string | null }> = [];
}

export class OrdersFilterData {
    filter: OrdersFilterRequest | null = null;
    filterTabs: Array<{ id: string; name: string; value: string | null }> = [];
}

export class InterfacesFilterData {
    filter: InterfaceFilterRequest | null = null;
    filterTabs: Array<{ id: string; name: string; value: string }> = [];
    hiddenFilter: boolean = false;
}
